import { Link } from "react-router-dom";
import "../styles/Hero.css";
import "../styles/Home.css";
import { useState, useEffect, useRef } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import heroBanner from "../assets/website1.png";
// import heroBanner1 from "../assets/second-website1.png";
// import firstColumn1 from "../assets/second-website1.png";
// import firstColumn2 from "../assets/firstlineWebsite1.png";
// import firstColumn3 from "../assets/firstlineWebsite2.png";
// import firstColumn4 from "../assets/firstlineWebsite3.png";
// import firstColumn5 from "../assets/firstlineWebsite4.png";
// import firstColumn6 from "../assets/firstlineWebsite5.png";
// import firstColumn7 from "../assets/firstlineWebsite6.png";
// import firstColumn8 from "../assets/firstlineWebsite7.png";
// import secondColumn1 from "../assets/secondLineWebsite1.png";
// import secondColumn2 from "../assets/secondLineWebsite2.png";
// import secondColumn3 from "../assets/secondLineWebsite3.png";
// import secondColumn4 from "../assets/secondLineWebsite4.png";
// import secondColumn5 from "../assets/secondLineWebsite5.png";
// import thirdColumn1 from "../assets/thirdLineWebsite3.png";
// import thirdColumn2 from "../assets/thirdLineWebsite1.png";
// import thirdColumn3 from "../assets/thirdLineWebsite2.png";
// import thirdColumn5 from "../assets/thirdLineWebsite5.png";
import { FaStar, FaArrowRight } from "react-icons/fa6";
import { ReactTyped } from "react-typed";
import { HashLink } from "react-router-hash-link";
import Videos from "../assets/Hero-video.mp4";

export default function Hero() {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    // Reset state and force video reload when component mounts
    setVideoLoaded(false);

    if (videoRef.current) {
      videoRef.current.load();
    }
  }, []);

  return (
    <>
      <section className="hero homepage-hero-section" id="home">
        <div className="container">
          <div className="hero-content">
            <div className="hero-left">
              <div className="review-with-text-wrapper">
                <p className="review-with-text">
                  <span className="review-star-icon">
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                  </span>
                  Rated 5.00 Stars Out of 150+ Reviews
                </p>
              </div>
              <h1 className="hero-headline">
                The Shopify Development{" "}
                <ReactTyped
                  strings={["Agency", "Expert", "Partner", "Service"]}
                  typeSpeed={40}
                  backSpeed={40}
                  loop
                  className="type-write-text tywritter-heading-fonts"
                />
              </h1>
              <p className="subheadline hero-subheadline">
                Since 2020, we've become the trusted choice for ambitious DTC
                brands who refuse to settle for average results. Our clients
                don't just get websites — they get conversion-optimized,
                revenue-generating stores.
              </p>
              {/* <p className="home-hero-q hero-quote">
                "TechTCL doesn't chase clients. Quality clients seek us out
                because they know we deliver results that matter."
              </p> */}
              <div className="hero-ctas">
                <HashLink smooth to="/#booking" className="btn-primary">
                  Book Free Strategy Call
                  <FaArrowRight size={20} />
                </HashLink>
                {/* <HashLink
                  smooth
                  to="/#booking"
                  className="btn-white blur-vanish-left"
                >
                  Book Free Strategy Session
                </HashLink> */}
                <Link to="/services/shopify-development" className="btn-secondary">
                  Free Store Audit
                </Link>
              </div>
              <div className="credibility_section_style_one">
                <div className="credibility_text_block" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ display: "inline-flex", alignItems: "center", color: "#fbbf24", fontSize: 14 }}>
                    <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                  </span>
                  <h3 className="credibility_main_heading">
                    150+ Satisfied Customers
                  </h3>
                </div>
              </div>

              {/* Stats Bar */}
              <div className="hero-stats-bar" style={{ display: "flex", gap: 12, marginTop: 20, flexWrap: "wrap" }}>
                {[
                  { value: "150+", label: "Projects" },
                  { value: "15+", label: "Countries" },
                  { value: "100%", label: "Satisfaction" },
                  { value: "5.0★", label: "Rating" },
                ].map((s, i) => (
                  <div key={i} style={{ display: "flex", alignItems: "center", gap: 6, padding: "6px 14px", borderRadius: 8, background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.15)", whiteSpace: "nowrap" }}>
                    <span style={{ fontSize: 16, fontWeight: 800, color: "#fff" }}>{s.value}</span>
                    <span style={{ fontSize: 11, color: "rgba(255,255,255,0.6)" }}>{s.label}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="hero-right">
              <div className="portfolio-wrapper">
                {/* <div className="hero-slider__wrapper">
                  <div className="hero-slider__column">
                    <div className="hero-slider__track">
                      <div className="hero-slider__slide">
                        <img src={heroBanner1} alt="Project 1" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={firstColumn5} alt="Project 2" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={firstColumn2} alt="Project 3" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={firstColumn8} alt="Project 4" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={firstColumn6} alt="Project 5" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={heroBanner1} alt="Project 1" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={firstColumn5} alt="Project 2" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={firstColumn2} alt="Project 3" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={firstColumn8} alt="Project 4" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={firstColumn6} alt="Project 5" />
                      </div>
                    </div>
                  </div>

                  <div className="hero-slider__column">
                    <div className="hero-slider__track2">
                      <div className="hero-slider__slide">
                        <img src={secondColumn1} alt="Project 1" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={secondColumn5} alt="Project 2" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={secondColumn2} alt="Project 3" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={secondColumn3} alt="Project 4" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={secondColumn4} alt="Project 5" />
                      </div>

                      <div className="hero-slider__slide">
                        <img src={secondColumn1} alt="Project 1" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={secondColumn5} alt="Project 2" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={secondColumn2} alt="Project 3" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={secondColumn3} alt="Project 4" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={secondColumn4} alt="Project 5" />
                      </div>
                    </div>
                  </div>

                  <div className="hero-slider__column">
                    <div className="hero-slider__track">
                      <div className="hero-slider__slide">
                        <img src={thirdColumn1} alt="Project 1" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={thirdColumn2} alt="Project 2" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={firstColumn3} alt="Project 3" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={thirdColumn3} alt="Project 4" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={thirdColumn5} alt="Project 5" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={thirdColumn1} alt="Project 3" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={thirdColumn2} alt="Project 1" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={firstColumn3} alt="Project 2" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={thirdColumn3} alt="Project 4" />
                      </div>
                      <div className="hero-slider__slide">
                        <img src={thirdColumn5} alt="Project 5" />
                      </div>
                    </div>
                  </div>
                </div> */}
                {!videoLoaded && (
                  <div className="video-skeleton-wrapper">
                    <div className="skeleton-lines-container">
                      <div className="skeleton-column">
                        <Skeleton className="skeleton-website-card" />
                        <Skeleton className="skeleton-website-card" />
                        <Skeleton className="skeleton-website-card" />
                      </div>

                      <div className="skeleton-column">
                        <Skeleton className="skeleton-website-card" />
                        <Skeleton className="skeleton-website-card" />
                        <Skeleton className="skeleton-website-card" />
                      </div>

                      <div className="skeleton-column">
                        <Skeleton className="skeleton-website-card" />
                        <Skeleton className="skeleton-website-card" />
                        <Skeleton className="skeleton-website-card" />
                      </div>
                    </div>
                  </div>
                )}
                <video
                  ref={videoRef}
                  width="100%"
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="hero-video-wrapper"
                  style={{ display: videoLoaded ? "block" : "none" }}
                  onLoadedData={() => setVideoLoaded(true)}
                  onCanPlay={() => setVideoLoaded(true)} // Backup event
                >
                  <source
                    src="https://cdn.shopify.com/videos/c/o/v/d8aa1f4fd4a64bf78894f289630dc4fc.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
